import { render } from "./AppAlert.vue?vue&type=template&id=dc2b36f8&ts=true"
import script from "./AppAlert.vue?vue&type=script&lang=ts"
export * from "./AppAlert.vue?vue&type=script&lang=ts"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__